var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import * as React from "react";
import styled from "styled-components";
import { bonfireGet } from "../../theme";
import { classnames } from "../../utils";
import { Tab } from "../TabViewer";
import { Button } from "../Button";
import { Checkbox } from "../Checkbox";
import { ViewIcon } from "../Icons/ViewIcon";
import { Tag } from "../Tag";
import { Text } from "../Text";
import { TextField } from "../TextField";
function isStaticSource(value) {
    return "items" in value;
}
function isAsyncSource(value) {
    return "fetchItems" in value;
}
var TabbedSelectionListStyle = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n\n  .bn-tabbedselectionlist-search {\n    flex: 0;\n    margin-bottom: 15px;\n  }\n\n  .bn-tabbedselectionlist-search-inner {\n    padding: 25px 25px 0 25px;\n  }\n\n  .bn-tabbedselectionlist-load-noresult {\n    margin-top: 25px;\n    margin-left: 20px;\n    text-align: center;\n  }\n\n  .bn-tabbedselectionlist-search-noresult {\n    margin-top: 25px;\n  }\n\n  .bn-tabbedselectionlist-selectedtag {\n    cursor: pointer;\n  }\n\n  .bn-tabbedselectionlist-tabs {\n    padding: 0 4px;\n  }\n\n  .bn-tabbedselectionlist-content {\n    border: 1px solid ", ";\n    background: ", ";\n    border-radius: 4px;\n\n    flex: 1;\n    min-height: 0;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .bn-tabbedselectionlist-footer {\n    border-top: 1px solid ", ";\n    margin-top: auto;\n  }\n  .tabbedselectionlist-select-all {\n    text-align: left;\n  }\n  .tabbedselectionlist-reset {\n    float: right;\n  }\n\n  .bn-tabbedselectionlist-list {\n    height: 100%;\n    box-sizing: border-box;\n    overflow-y: auto;\n    list-style: none;\n    margin: 0;\n    padding: 8px 0px;\n    padding-left: 25px;\n  }\n\n  .bn-tabbedselectionlist-item {\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n    margin: 6px 0px;\n    margin-right: 25px;\n  }\n\n  .bn-tabbedselectionlist-item-contentright {\n    margin-left: auto;\n    // We can contain svg icons, which are inline elements.\n    // The browser will treat these as text-like and try to insert\n    // spacing underneath them.  Cancel this by clearing out line-height.\n    // FIXME: Should this be in bonfire?\n    line-height: 0;\n  }\n\n  .bn-tabbedselectionlist-viewicon {\n    margin-right: 6px;\n  }\n\n  .bn-tag-label {\n    display: flex;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n\n  .bn-tabbedselectionlist-search {\n    flex: 0;\n    margin-bottom: 15px;\n  }\n\n  .bn-tabbedselectionlist-search-inner {\n    padding: 25px 25px 0 25px;\n  }\n\n  .bn-tabbedselectionlist-load-noresult {\n    margin-top: 25px;\n    margin-left: 20px;\n    text-align: center;\n  }\n\n  .bn-tabbedselectionlist-search-noresult {\n    margin-top: 25px;\n  }\n\n  .bn-tabbedselectionlist-selectedtag {\n    cursor: pointer;\n  }\n\n  .bn-tabbedselectionlist-tabs {\n    padding: 0 4px;\n  }\n\n  .bn-tabbedselectionlist-content {\n    border: 1px solid ", ";\n    background: ", ";\n    border-radius: 4px;\n\n    flex: 1;\n    min-height: 0;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .bn-tabbedselectionlist-footer {\n    border-top: 1px solid ", ";\n    margin-top: auto;\n  }\n  .tabbedselectionlist-select-all {\n    text-align: left;\n  }\n  .tabbedselectionlist-reset {\n    float: right;\n  }\n\n  .bn-tabbedselectionlist-list {\n    height: 100%;\n    box-sizing: border-box;\n    overflow-y: auto;\n    list-style: none;\n    margin: 0;\n    padding: 8px 0px;\n    padding-left: 25px;\n  }\n\n  .bn-tabbedselectionlist-item {\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n    margin: 6px 0px;\n    margin-right: 25px;\n  }\n\n  .bn-tabbedselectionlist-item-contentright {\n    margin-left: auto;\n    // We can contain svg icons, which are inline elements.\n    // The browser will treat these as text-like and try to insert\n    // spacing underneath them.  Cancel this by clearing out line-height.\n    // FIXME: Should this be in bonfire?\n    line-height: 0;\n  }\n\n  .bn-tabbedselectionlist-viewicon {\n    margin-right: 6px;\n  }\n\n  .bn-tag-label {\n    display: flex;\n  }\n"])), bonfireGet("colors", "surfaceDark"), bonfireGet("colors", "backgroundLight"), bonfireGet("colors", "surfaceVariantLight"));
var TabbedSelectionList = function (_a) {
    var id = _a.id, className = _a.className, style = _a.style, sources = _a.sources, selectedItems = _a.selectedItems, _b = _a.allowNewItem, allowNewItem = _b === void 0 ? "if-empty" : _b, onSelectedItemsChanged = _a.onSelectedItemsChanged, renderItemLabel = _a.renderItemLabel, renderItemRightContent = _a.renderItemRightContent, _c = _a.exposeSourceError, exposeSourceError = _c === void 0 ? false : _c, _d = _a.alwaysShowOptions, alwaysShowOptions = _d === void 0 ? false : _d, _e = _a.searchScope, searchScope = _e === void 0 ? "global" : _e;
    var _f = __read(React.useState(sources[0] != null ? sources[0].key : null), 2), selectedSourceKey = _f[0], setSelectedSourceKey = _f[1];
    var selectedSource = sources.find(function (_a) {
        var key = _a.key;
        return key === selectedSourceKey;
    });
    if (selectedSourceKey == null || !selectedSource) {
        throw new Error("[TabbedSelectionList]: No item source available.");
    }
    var _g = __read(React.useState(false), 2), isShowingSelected = _g[0], setShowingSelected = _g[1];
    var _h = __read(React.useState(""), 2), searchText = _h[0], setSearchText = _h[1];
    var _j = __read(React.useState(null), 2), currentSourceItems = _j[0], setCurrentSourceItems = _j[1];
    var _k = __read(React.useState(null), 2), currentSourceError = _k[0], setCurrentSourceError = _k[1];
    var _l = __read(React.useState({}), 2), searchTabContent = _l[0], setSearchTabContent = _l[1];
    var _m = __read(React.useState(0), 2), retryCounter = _m[0], setRetryCounter = _m[1];
    var onSearchTextChange = React.useCallback(function (e) {
        setSearchText(e.target.value);
        if (e.target.value !== "") {
            setShowingSelected(false);
        }
    }, []);
    var onShowSelectedToggle = React.useCallback(function () {
        setShowingSelected(function (value) { return !value; });
        setSearchText("");
        setSearchTabContent({});
    }, []);
    var onRetry = React.useCallback(function () {
        setRetryCounter(function (value) { return value + 1; });
    }, []);
    var onChangeSourceKey = function (key) {
        var _a;
        if (searchScope === "per-tab" && key) {
            setSearchTabContent(__assign(__assign({}, searchTabContent), (_a = {}, _a[selectedSourceKey] = searchText, _a)));
            setSearchText(searchTabContent[key] || "");
        }
        setSelectedSourceKey(key);
    };
    // When Select All is clicked while showing already selected elements, we do not want to duplciate those elements
    var onSelectAll = React.useCallback(function () {
        // we need to persist selections in other tabs when selecting all in another tab
        var incomingSelectedItems = selectedItems.filter(function (selectedItem) { return selectedItem.sourceKey !== selectedSourceKey; });
        if (currentSourceItems) {
            incomingSelectedItems.filter(function (selectedItem) {
                !currentSourceItems.find(function (sourceItem) { return sourceItem.value === selectedItem.value; });
            });
        }
        onSelectedItemsChanged(__spreadArray(__spreadArray([], __read(currentSourceItems), false), __read(incomingSelectedItems), false));
    }, [currentSourceItems, selectedItems]);
    var onReset = React.useCallback(function () {
        if (alwaysShowOptions) {
            var filterSelectionsByTab = selectedItems.filter(function (selectedItem) { return selectedItem.sourceKey !== selectedSourceKey; });
            onSelectedItemsChanged(filterSelectionsByTab);
        }
        else {
            onSelectedItemsChanged([]);
        }
    }, [selectedItems, searchTabContent]);
    React.useEffect(function () {
        if (isShowingSelected) {
            return;
        }
        var source = selectedSource;
        var sourceKey = selectedSourceKey;
        if (isStaticSource(source)) {
            // Set the state immediately without allowing a null value to pass.
            // This ensures that we do not flicker on the loading indicator during rerenders,
            // particularly when items are selected.
            setCurrentSourceItems(source.items
                .filter(function (item) { return caseInsensitiveContains(item.label, searchText); })
                .map(function (item) { return (__assign(__assign({}, item), { sourceKey: sourceKey })); }));
        }
        else if (isAsyncSource(source)) {
            setCurrentSourceItems(null);
            source
                .fetchItems({ searchText: searchText })
                .then(function (items) { return items.map(function (item) { return (__assign(__assign({}, item), { sourceKey: sourceKey })); }); })
                .then(setCurrentSourceItems)
                .catch(function (e) {
                console.error(e);
                setCurrentSourceError(e.message);
            });
        }
        else {
            throw new Error("[TabbedSelectionList]: Unknown source type for ".concat(sourceKey));
        }
    }, [
        retryCounter,
        isShowingSelected,
        selectedSourceKey,
        searchText,
        selectedSource
    ]);
    var displayLoading = !isShowingSelected && !currentSourceError && currentSourceItems == null;
    var displayError = !isShowingSelected && currentSourceError;
    var onItemInclusionChanged = React.useCallback(function (item, included) {
        if (!included) {
            onSelectedItemsChanged(selectedItems.filter(function (_a) {
                var sourceKey = _a.sourceKey, value = _a.value;
                return sourceKey !== item.sourceKey || value !== item.value;
            }));
        }
        else {
            onSelectedItemsChanged(__spreadArray(__spreadArray([], __read(selectedItems), false), [item], false));
        }
    }, [selectedItems, onSelectedItemsChanged]);
    var content;
    if (displayLoading) {
        content = React.createElement(Text, null, "Loading");
    }
    else if (displayError) {
        content = (React.createElement(Text, { className: "bn-tabbedselectionlist-load-noresult" },
            exposeSourceError
                ? currentSourceError
                : "Error occurred while loading the items.",
            React.createElement(Button, { variant: "link", onClick: onRetry }, "Click here to retry")));
    }
    else {
        var displayItems = void 0;
        // When searchbar is inset and dependent on each tab,
        // the filteredSelectedItems should reflect each tab on its own
        var filteredSelectedItems = selectedItems.filter(function (item) {
            return caseInsensitiveContains(item.label, searchText);
        });
        if (searchScope === "per-tab") {
            filteredSelectedItems = selectedItems.filter(function (item) {
                return caseInsensitiveContains(item.label, searchText) &&
                    item.sourceKey === selectedSourceKey;
            });
        }
        if (isShowingSelected) {
            // The search term gets cleared when selected mode toggles, but keeping it
            // this way for completeness.
            displayItems = filteredSelectedItems;
        }
        else {
            // Search term still needs to apply to the current tab's custom-selection items.
            displayItems = __spreadArray([], __read(currentSourceItems), false);
            displayItems = addUniqueItems(displayItems, filteredSelectedItems.filter(function (x) { return x.sourceKey === selectedSourceKey; }));
            if (selectedSource.createNewItemFromSearch &&
                searchText.length > 0 &&
                ((allowNewItem === "if-empty" && displayItems.length === 0) ||
                    allowNewItem === "always")) {
                // No items to display but our source can create new items from the search.
                var item = selectedSource.createNewItemFromSearch(searchText);
                if (item) {
                    displayItems = addUniqueItems(displayItems, [
                        __assign(__assign({}, item), { sourceKey: selectedSourceKey })
                    ]);
                }
            }
        }
        if (displayItems.length === 0 && searchText) {
            content = (React.createElement(Text, { className: "bn-tabbedselectionlist-search-noresult" }, "Search has no results"));
        }
        else {
            content = (React.createElement("ul", { className: "bn-tabbedselectionlist-list" }, displayItems.map(function (item) { return (React.createElement(TabbedSelectionListCheckbox, { key: "".concat(item.sourceKey, "::").concat(item.value), item: item, label: renderItemLabel ? renderItemLabel(item) : item.label, rightContent: renderItemRightContent
                    ? renderItemRightContent(item)
                    : undefined, included: selectedItems.find(function (_a) {
                    var sourceKey = _a.sourceKey, value = _a.value;
                    return item.sourceKey === sourceKey && item.value === value;
                }) != null, onItemInclusionChanged: onItemInclusionChanged })); })));
        }
    }
    if (sources.length === 0) {
        throw new Error("[TabbedSelectionList]: At least one item source is required.");
    }
    return (React.createElement(TabbedSelectionListStyle, { id: id, className: classnames("bn-tabbedselectionlist", className), style: style },
        searchScope === "global" && (React.createElement(SearchBox, { searchScope: searchScope, selectedSourceKey: selectedSourceKey, selectedItems: selectedItems, searchText: searchText, onSearchTextChange: onSearchTextChange, onShowSelectedToggle: onShowSelectedToggle, backgroundColor: isShowingSelected ? "linkLight" : "surface" })),
        React.createElement("div", { className: "bn-tabbedselectionlist-tabs" }, sources.map(function (_a) {
            var key = _a.key, label = _a.label;
            return (React.createElement(Tab, { activeTab: selectedSourceKey !== null && selectedSourceKey !== void 0 ? selectedSourceKey : "", tabId: key, onClick: function () { return onChangeSourceKey(key); } }, label));
        })),
        React.createElement("div", { className: "bn-tabbedselectionlist-content" },
            searchScope === "per-tab" && (React.createElement(SearchBox, { searchScope: searchScope, selectedSourceKey: selectedSourceKey, selectedItems: selectedItems, searchText: searchText, onSearchTextChange: onSearchTextChange, onShowSelectedToggle: onShowSelectedToggle, backgroundColor: isShowingSelected ? "linkLight" : "surface" })),
            content,
            React.createElement("div", { className: "bn-tabbedselectionlist-footer" },
                (searchText || alwaysShowOptions) && (React.createElement(Button, { className: "tabbedselectionlist-select-all", variant: "link", onClick: onSelectAll }, "Select All")),
                React.createElement(Button, { className: "tabbedselectionlist-reset", variant: "link", disabled: selectedItems.length === 0, onClick: onReset }, "Reset")))));
};
export default TabbedSelectionList;
function addUniqueItems(items, itemsToAdd) {
    var e_1, _a;
    var result = __spreadArray([], __read(items), false);
    var _loop_1 = function (newItem) {
        var value = newItem.value;
        if (result.find(function (x) { return x.value === value; })) {
            return "continue";
        }
        // Selected item is not yet in display items, add it.
        result.push(newItem);
    };
    try {
        // Add in items that are not in the source items.
        for (var itemsToAdd_1 = __values(itemsToAdd), itemsToAdd_1_1 = itemsToAdd_1.next(); !itemsToAdd_1_1.done; itemsToAdd_1_1 = itemsToAdd_1.next()) {
            var newItem = itemsToAdd_1_1.value;
            _loop_1(newItem);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (itemsToAdd_1_1 && !itemsToAdd_1_1.done && (_a = itemsToAdd_1.return)) _a.call(itemsToAdd_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return result;
}
function caseInsensitiveContains(value, searchText) {
    searchText = searchText.toLowerCase();
    return value.toLowerCase().indexOf(searchText) !== -1;
}
var TabbedSelectionListCheckbox = function (_a) {
    var item = _a.item, label = _a.label, rightContent = _a.rightContent, included = _a.included, onItemInclusionChanged = _a.onItemInclusionChanged;
    var onChange = React.useCallback(function (e) {
        onItemInclusionChanged(item, e.target.checked);
    }, [item, onItemInclusionChanged]);
    return (React.createElement("div", { className: "bn-tabbedselectionlist-item" },
        React.createElement(Checkbox, { className: "bn-tabbedselectionlist-checkbox", checked: included, onChange: onChange }, label),
        rightContent && (React.createElement("div", { className: "bn-tabbedselectionlist-item-contentright" }, rightContent))));
};
var SearchBox = function (_a) {
    var selectedItems = _a.selectedItems, selectedSourceKey = _a.selectedSourceKey, searchText = _a.searchText, backgroundColor = _a.backgroundColor, onShowSelectedToggle = _a.onShowSelectedToggle, onSearchTextChange = _a.onSearchTextChange, searchScope = _a.searchScope;
    var textFieldClassNames = searchScope === "global"
        ? "bn-tabbedselectionlist-search"
        : "bn-tabbedselectionlist-search  bn-tabbedselectionlist-search-inner";
    return (React.createElement(TextField, { className: textFieldClassNames, inlinePrefixElement: React.createElement(Tag, { className: "bn-tabbedselectionlist-selectedtag", backgroundColor: backgroundColor, onClick: onShowSelectedToggle },
            React.createElement(ViewIcon, { iconColor: "textLight", size: "small", className: "bn-tabbedselectionlist-viewicon" }),
            " ",
            selectedItems.filter(function (item) {
                return searchScope === "per-tab"
                    ? selectedSourceKey === item.sourceKey
                    : true;
            }).length,
            " ",
            "Selected"), placeholder: "Search", value: searchText, onChange: onSearchTextChange }));
};
var templateObject_1;
//# sourceMappingURL=TabbedSelectionList.js.map